import React, { useState } from "react";
import { View, Text } from "react-native-web";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import moment from "moment-timezone";
//components

//images
import emptyProduct from "../../../asset/images/product/inventory/emptyProduct.png";

//functions
import PageButtonNavigate from "../../../components/button/PageButtonNavigate";

const ShippingTable = (props) => {
  const { tableHeader = [], tableData = [] } = props;

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const pagesCount = Math.ceil(tableData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const tableDataSliced = tableData.slice(startIndex, endIndex);

  const { onSelect } = props;

  return tableData.length > 0 ? (
    <View style={{ width: "100%", height: "100%" }}>
      <TableContainer sx={styles.tableContainer}>
        <Table sx={styles.table}>
          <TableHead sx={{ position: "sticky", top: 0, zIndex: 9999 }}>
            <TableRow style={{ width: "100%", backgroundColor: "#FFF" }}>
              <TableCell sx={{ ...styles.headerCell }}>เลขที่จัดส่ง</TableCell>
              <TableCell sx={{ ...styles.headerCell }}>เลขที่การขาย</TableCell>
              <TableCell sx={{ ...styles.headerCell }}>รูปแบบการส่ง</TableCell>
              <TableCell sx={{ ...styles.headerCell }}>
                ยอดเก็บเงินปลายทาง
              </TableCell>
              <TableCell sx={{ ...styles.headerCell, width: 140 }}>
                ชื่อผู้ส่ง
              </TableCell>
              <TableCell sx={{ ...styles.headerCell, width: 140 }}>
                ลูกค้า
              </TableCell>
              <TableCell sx={{ ...styles.headerCell }}>วันที่/เวลา</TableCell>
              <TableCell sx={{ ...styles.headerCell, width: 240 }}>
                ที่อยู่
              </TableCell>
              <TableCell sx={{ ...styles.headerCell }}>เบอร์โทรศัพท์</TableCell>
              <TableCell sx={{ ...styles.headerCell }}>
                สถานะการพิมพ์ใบปะหน้า
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tableDataSliced.map((row) => {
              return (
                <TableRow key={row.id} sx={styles.tableRow}>
                  <TableCell sx={styles.tableCell}>
                    <Text>{row.trackingCode ? row.trackingCode : "-"}</Text>
                  </TableCell>
                  <TableCell sx={styles.tableCell}>
                    <Text>{row.retailCode ? row.retailCode : "-"}</Text>
                  </TableCell>{" "}
                  <TableCell sx={{ ...styles.tableCell, width: 140 }}>
                    <Text>{row.transportName ? row.transportName : "-"}</Text>
                  </TableCell>{" "}
                  <TableCell sx={styles.tableCell}>
                    <Text>
                      {row.codAmount
                        ? Number(row.codAmount).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                        })
                        : "0.00"}
                    </Text>
                  </TableCell>{" "}
                  <TableCell sx={styles.tableCell}>
                    <Text>{row.sendingName ? row.sendingName : "-"}</Text>
                  </TableCell>{" "}
                  <TableCell sx={styles.tableCell}>
                    <Text>{row.customerName ? row.customerName : "-"}</Text>
                  </TableCell>{" "}
                  <TableCell sx={styles.tableCell}>
                    <Text>
                      {row.date
                        ? moment(row.date).format("DD/MM/YYYY HH:mm")
                        : "-"}
                    </Text>
                  </TableCell>{" "}
                  <TableCell sx={styles.tableCell}>
                    <Text>{row.allAddress ? row.allAddress : "-"}</Text>
                  </TableCell>{" "}
                  <TableCell sx={styles.tableCell}>
                    <Text>{row.phoneNumber ? row.phoneNumber : "-"}</Text>
                  </TableCell>{" "}
                  <TableCell sx={styles.tableCell}>
                    <Text></Text>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <PageButtonNavigate
        currentPage={currentPage}
        pagesCount={pagesCount}
        startIndex={startIndex}
        endIndex={endIndex}
        dataCount={tableData.length}
        onSelectPage={(page) => {
          setCurrentPage(page);
        }}
      />
    </View>
  ) : (
    <EmptyList />
  );
};

const EmptyList = () => {
  return (
    <View
      style={{
        flex: 1,
        height: "100%",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img src={emptyProduct} style={{ width: 120 }} alt={"emptyProduct"} />
      <View style={{ height: 30 }} />
      <Text
        style={{
          fontSize: "clamp(16px,2vh,20px)",
          fontWeight: "bold",
          color: "rgba(15, 16, 17, 1)",
        }}
      >
        ยังไม่มีรายการ
      </Text>
    </View>
  );
};

const styles = {
  headerCell: {
    color: "rgba(165, 88, 90, 1)",
    whiteSpace: "nowrap", // ป้องกันการขึ้นบรรทัดใหม่
    overflow: "hidden", // ป้องกันข้อความล้นออกนอกเซลล์
    textOverflow: "ellipsis", // แสดงเครื่องหมาย ellipsis สำหรับข้อความที่ยาวเกินไป
  },

  tableContainer: {
    overflowY: "scroll",
    scrollbarWidth: "thin",
    scrollbarColor: "#c7c7c7 #f5f5f5",
    flex: 1,
    width: "100%", // Ensure the container is wide enough
  },
  table: {
    border: "none",
    minWidth: 650, // Adjust as needed to ensure table is wide enough
    width: "100%", // Set the table to fill its container
  },
  tableRow: {
    "&:nth-of-type(odd)": {
      backgroundColor: "rgba(255, 255, 255, 1)",
    },
    "&:nth-of-type(even)": {
      backgroundColor: "rgba(255, 241, 241, 1)",
    },
  },
  tableCell: {
    borderBottom: "none",
    whiteSpace: "nowrap",
    overflow: "hidden", // Prevent text from spilling out
    textOverflow: "ellipsis", // Add ellipsis for overflowing text
    lineHeight: "normal",
  },
};

export default ShippingTable;
